import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  ResponsiveContainer,
  Tooltip
} from 'recharts';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { SERVER_URL } from '../../../config';

export default function PlayerReport({ playerId }) {

  const [soccerReportData, setSoccerReportData] = useState(null);
    
 console.log("playerId",playerId)
  const [activeTab, setActiveTab] = useState('div2');
  const [selectedCategory, setSelectedCategory] = useState('Behavioural Traits');
  const [files, setFiles] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = sessionStorage.getItem('club_token');

  const reportSections = [
    { key: 'diet', label: 'Nutrition' },
    { key: 'soccer', label: 'Soccer' },
    { key: 'fitness', label: 'Fitness' },
  ];

const fetchSoccerReport = async () => {
  try {
    const response = await axios.get(`${SERVER_URL}/api/v2/club/get-user-soccer-report/${playerId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (response.data.status) {
      setSoccerReportData(response.data.data);
    }
  } catch (err) {
    console.error('Failed to fetch soccer report:', err);
    const msg = err.response?.data?.message || 'Failed to fetch soccer report.';
    toast.error(msg);
    if (
      msg.includes('expired') ||
      msg.includes('invalidated') ||
      msg.includes('Invalid token') ||
      msg.includes('token is required')
    ) {
      setTimeout(() => {
        toast.dismiss();
        navigate('/club/login');
      }, 1500);
    }
  }
};

  useEffect(() => {
    const fetchAllReports = async () => {
      if (!token || !playerId) {
        toast.error('No authentication token or player ID found. Please log in.');
        setTimeout(() => {
          navigate('/club/login');
        }, 2000);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${SERVER_URL}/api/v2/club/get-user-all-report/${playerId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.status) {
          setFiles(response.data.files || {});
        } else {
          toast.error(response.data.message || 'Failed to fetch reports.');
        }
      } catch (err) {
        const msg = err?.response?.data?.message || 'Something went wrong.';
        console.error('API Error:', msg);
        toast.error(msg);
        if (
          msg.includes('expired') ||
          msg.includes('invalidated') ||
          msg.includes('Invalid token') ||
          msg.includes('token is required')
        ) {
          setTimeout(() => {
            navigate('/club/login');
          }, 2000);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchAllReports();
    fetchSoccerReport();
  }, [token, playerId, navigate]);



  const handleActiveTab = (tab) => {
    setActiveTab(tab);
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setActiveTab('div2');
  };

  const radarData = soccerReportData && soccerReportData[selectedCategory]?.map(item => ({
    subject: item.Condition,
    A: item.Risk === 'HIGH' ? 90 : item.Risk === 'MEDIUM-HIGH' ? 75 : item.Risk === 'MEDIUM' ? 60 : 45,
  })) || [];

  const strengthsData = soccerReportData && soccerReportData[selectedCategory]?.map(item => ({
    type: item.Condition,
    percent: item.Risk === 'HIGH' ? 90 : item.Risk === 'MEDIUM-HIGH' ? 75 : item.Risk === 'MEDIUM' ? 60 : 45,
  })) || [];

  const isDataEmpty = !soccerReportData || Object.keys(soccerReportData).length === 0;

  return (
    <div>
      {isDataEmpty ? (
        <div className="relative w-full h-[600px] bg-black/20 rounded-3xl flex items-center justify-center">
          <div className="absolute inset-0 backdrop-blur-md"></div>
          <div className="relative text-center text-white z-10">
            <h2 className="text-2xl font-bold mb-4">DNA Test Results Pending</h2>
            <p className="text-lg">The player's genetic profile data will be updated once their DNA test is completed. Please check back later.</p>
          </div>
        </div>
      ) : (
        <>
          {activeTab === 'div1' && (
            <div className='flex flex-col lg:flex-row gap-10 mt-10'>
              <div className='w-[100%] lg:w-[30%] bg-white/15 rounded-3xl p-5 grid content-between'>
                <div className='relative'>
                  <div className='grid text-center absolute top-6 left-4 text-[#00ff00] text-sm'>
                    Health Score
                    <span className='text-3xl font-semibold'>00%</span>
                  </div>
                  <img src='/assets/others/Healthreport.svg' className='w-[80%] mx-auto' alt="Health Report" />
                </div>
                <button onClick={() => handleActiveTab('div2')} className='w-full bg-[#5F33D6] flex items-center justify-center gap-3 py-2 border border-white/15 rounded-full relative overflow-hidden text-lg font-medium'>
                  <div className='w-[90%] h-2 rounded bg-white absolute top-1 blur-lg'></div>
                  <img src='/assets/icon/magic.svg' alt="Magic Icon" /> Book Appointment
                </button>
                <button className='mt-3 border border-white/15 bg-[#2B2B2B] rounded-full py-2.5 px-3 w-full relative overflow-hidden'>
                  + Add Health Data
                  <img src='/assets/others/noise.png' className='absolute w-full h-full opacity-10' style={{ zIndex: 0 }} alt="Noise Texture" />
                </button>
              </div>
              <div className='w-[100%] lg:w-[30%] bg-white/15 rounded-3xl p-5 grid content-between'>
                <img src='/assets/others/BP.svg' className='w-[80%] mx-auto' alt="Blood Pressure" />
                <div className='grid text-center text-[#00FF0D] text-sm'><span className='text-3xl font-semibold'>00</span> mg/dl</div>
                <button className='mt-3 border border-white/15 bg-[#2B2B2B] rounded-full py-2.5 px-3 w-full relative overflow-hidden'>
                  + Add Health Data
                  <img src='/assets/others/noise.png' className='absolute w-full h-full opacity-10' style={{ zIndex: 0 }} alt="Noise Texture" />
                </button>
              </div>
              <div className='w-[100%] lg:w-[40%] space-y-5'>
                <div className='border py-3 px-5 rounded-full flex items-center gap-3 bg-gradient-to-r from-[#424C5F00] to-[#2F1073]'>
                  <div className='p-1.5 bg-gradient-to-r from-white to-transparent rounded-full w-full'>
                    <div className='bg-[#FF0000] h-3 rounded-full w-[72%]'></div>
                  </div>
                  <div className='relative flex justify-center items-center'>
                    <div className='grid text-center text-xl font-semibold absolute'><p className='translate-y-1'>72</p> <span className='text-xs 2xl:text-sm font-normal -translate-y-1'>bpm</span></div>
                    <img src='/assets/others/heartrate.svg' alt="Heart Rate" />
                  </div>
                </div>
                <div className='border py-3 px-5 rounded-full flex items-center gap-3 bg-gradient-to-r from-[#424C5F00] to-[#2F1073]'>
                  <div className='w-full'>
                    <div className='p-1.5 bg-gradient-to-r from-white to-transparent rounded-full w-full'>
                      <div className='bg-[#00FF00] h-3 rounded-full w-[72%]'></div>
                    </div>
                    <p className='text-end text-sm mt-1'>Enter Data <span className='text-[#00FF00] font-medium text-base'> 00 Cal</span></p>
                  </div>
                  <div className='relative'>
                    <img src='/assets/others/food.svg' alt="Food Intake" />
                  </div>
                </div>
                <div className='border py-3 px-5 rounded-full flex items-center gap-3 bg-gradient-to-r from-[#424C5F00] to-[#2F1073]'>
                  <div className='w-full'>
                    <div className='p-1.5 bg-gradient-to-r from-white to-transparent rounded-full w-full'>
                      <div className='bg-[#0080FF] h-3 rounded-full w-[72%]'></div>
                    </div>
                    <p className='text-end text-sm mt-1'><span className='text-[#00FF00] font-medium text-base'> 6 Glasses</span> / 8 Glasses Per Day</p>
                  </div>
                  <div className='relative'>
                    <img src='/assets/others/water.svg' alt="Water Intake" />
                  </div>
                </div>
                <div className='border py-3 px-5 rounded-full flex items-center gap-3 bg-gradient-to-r from-[#424C5F00] to-[#2F1073]'>
                  <div className='w-full'>
                    <div className='p-1.5 bg-gradient-to-r from-white to-transparent rounded-full w-full'>
                      <div className='bg-[#9DFF00] h-3 rounded-full w-[72%]'></div>
                    </div>
                    <p className='text-end text-sm mt-1'><span className='text-[#00FF00] font-medium text-base'>2635 Steps</span> / 5000 Steps Per Day</p>
                  </div>
                  <div className='relative'>
                    <img src='/assets/others/footsteps.svg' alt="Steps" />
                  </div>
                </div>
              </div>
            </div>
          )}
          {activeTab === 'div2' && (
            <div className='flex flex-col lg:flex-row gap-10 mt-10'>
          
                <>
                  <div className='w-[100%] lg:w-[55%] border rounded-3xl text-black'>
                    <ResponsiveContainer width="100%" height={400}>
                      <RadarChart cx="50%" cy="50%" outerRadius="80%" data={radarData}>
                        <PolarGrid />
                        <PolarAngleAxis dataKey="subject" tick={{ fill: 'white' }} />
                        <Tooltip />
                        <Radar
                          name="Strength"
                          dataKey="A"
                          stroke="url(#radarGradient)"
                          fill="url(#radarGradient)"
                          fillOpacity={0.8}
                        />
                        <defs>
                          <linearGradient id="radarGradient" x1="0" y1="0" x2="1" y2="0">
                            <stop offset="0%" stopColor="#4776E6" />
                            <stop offset="100%" stopColor="#8E54E9" />
                          </linearGradient>
                        </defs>
                      </RadarChart>
                    </ResponsiveContainer>
                  </div>
                  <div className='w-[100%] lg:w-[45%]'>
                    <div className='w-full space-y-4'>
                      {strengthsData.map((item, index) => (
                        <div key={index} className='w-full'>
                          <p>{item.type}</p>
                          <div className='mt-3 relative'>
                            <div className='absolute -top-4 text-xs font-medium' style={{ left: `calc(${item.percent}% - 2%)` }}>{item.percent}%</div>
                            <div className='bg-gradient-to-r from-white from-80% to-black w-full rounded-full'>
                              <div className='rounded-full bg-gradient-to-r from-[#00FF00] via-[#B94CF3] to-[#5C1FE2] h-3' style={{ width: `${item.percent}%` }}></div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    {/* <div className="flex flex-col lg:flex-row items-center justify-center gap-5 mt-5">
                      <button
                        onClick={() => handleCategoryChange('FullReport')}
                        className="border p-[2px] rounded-full flex items-center pl-5"
                      >
                        View Full Report
                        <div className="ml-5 w-8 h-8 rounded-full bg-white text-black grid place-content-center">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                      </button>
                    </div> */}  
                  </div>
                </>
            
            </div>
          )}
          <div className='border rounded-3xl px-3 lg:px-10 py-8 mt-10 duration-500 active:bg-gradient-to-b from-[#2F1073] to-[#424C5F00]'>
            <p className='text-center pb-7'>Get the Full Picture of the Player's Genetic Profile – Tap to Explore</p>
            <div className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-5'>
              {Object.keys(soccerReportData).map((category) => (
                <button
                  key={category}
                  onClick={() => handleCategoryChange(category)}
                  className={`border border-white/15 bg-[#2B2B2B] group rounded-full py-2 px-2 relative overflow-hidden duration-500 ${selectedCategory === category ? 'bg-[#5F33D6] border-b-4 border-b-white' : 'hover:bg-[#5F33D6]/80'
                    }`}
                >
                  <div className={`w-[90%] h-2 rounded absolute top-1 blur-lg duration-500 ${selectedCategory === category ? 'bg-white' : 'group-hover:bg-white'
                    }`}></div>
                  <span className='flex items-center justify-center gap-3 relative'>
                    <img src='/assets/icon/magic.svg' alt="Magic Icon" /> {category.replace(/([A-Z])/g, ' $1').trim()}
                  </span>
                  <img src='/assets/others/noise.png' className='absolute w-full h-full opacity-10' style={{ zIndex: 0 }} alt="Noise Texture" />
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}